import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Home, User, Clapperboard, Sparkles, Mail } from "lucide-react";
import { scrollToId } from "@/hooks/useLenis";

const LINKS = [
  { id: "home", label: "Home", Icon: Home, color: "var(--pink)" },
  { id: "about", label: "About", Icon: User, color: "var(--yellow)" },
  { id: "work", label: "Work", Icon: Clapperboard, color: "var(--blue)" },
  { id: "playground", label: "Playground", Icon: Sparkles, color: "var(--green)" },
];

export const Nav = ({ play }) => {
  const [active, setActive] = useState("home");

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setActive(e.target.id)),
      { rootMargin: "-40% 0px -55% 0px" }
    );
    [...LINKS, { id: "contact" }].forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) obs.observe(el);
    });
    return () => obs.disconnect();
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      className="fixed top-4 left-0 right-0 z-50 flex justify-center px-4"
      initial={{ y: -80, opacity: 0 }}
      animate={play ? { y: 0, opacity: 1 } : {}}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
    >
      <nav className="flex items-center gap-1 bg-[var(--paper)]/85 backdrop-blur-md border-[1.5px] border-[var(--ink)] rounded-xl px-2 py-1.5 hard-shadow">
        <span className="w-2.5 h-2.5 rounded-full bg-[var(--pink)] border border-[var(--ink)] ml-1 mr-2" />
        {LINKS.map(({ id, label, Icon, color }) => (
          <button
            key={id}
            data-testid={`nav-${id}`}
            onClick={() => scrollToId(id)}
            className="relative font-mono text-[0.68rem] uppercase tracking-[0.1em] px-3 py-1.5 rounded-md flex items-center gap-1.5 transition-colors"
            style={{ background: active === id ? color : "transparent", color: active === id && id === "work" ? "#fff" : "var(--ink)" }}
          >
            <Icon size={12} strokeWidth={2.2} />
            <span className="hidden sm:inline">{label}</span>
          </button>
        ))}
        <span className="hidden md:flex items-center gap-1.5 mx-3">
          <span className="w-2.5 h-2.5 rounded-full bg-[var(--yellow)] border border-[var(--ink)]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[var(--pink)] border border-[var(--ink)]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[var(--green)] border border-[var(--ink)]" />
        </span>
        <button
          data-testid="nav-contact"
          onClick={() => scrollToId("contact")}
          className="font-mono text-[0.68rem] uppercase tracking-[0.1em] px-3 py-1.5 rounded-md text-[var(--paper)] flex items-center gap-1.5 hover:bg-[var(--blue)] transition-colors"
          style={{ background: active === "contact" ? "var(--blue)" : "var(--ink)" }}
        >
          <Mail size={12} /> Contact
        </button>
      </nav>
    </motion.header>
  );
};
